import axiosInstance from '../variables/api/axiosInstance';
import { avecLibelleTraduit, libellesTraduits } from '../i18n/libelles';

const BASE = '/v1/admin/securite';

const unwrapPaginated = (res) => {
  const d = res?.data?.data;
  const list = Array.isArray(d) ? d : (d?.content || []);
  return {
    items: list,
    totalElements: res?.data?.totalElements ?? list.length,
    currentPage: res?.data?.currentPage ?? 0,
    pageSize: res?.data?.pageSize ?? list.length,
  };
};

/* ── Onglet « Tous les appareils » ── */
export async function listerAppareils(page = 0, size = 25, params = {}) {
  return unwrapPaginated(await axiosInstance.get(`${BASE}/appareils`, { params: { page, size, ...params } }));
}

export async function detailAppareil(lienId) {
  const res = await axiosInstance.get(`${BASE}/appareils/${lienId}`);
  return res?.data?.data || null;
}

/* ── Onglet « À valider » ── */
export async function listerDemandes(page = 0, size = 25, statut = 'EN_ATTENTE') {
  return unwrapPaginated(await axiosInstance.get(`${BASE}/demandes`, { params: { page, size, statut } }));
}

export async function compterDemandesEnAttente() {
  const res = await axiosInstance.get(`${BASE}/demandes/en-attente/compteur`, { skipErrorToast: true });
  return res?.data?.data ?? 0;
}

export async function approuverDemande(id, commentaire, dureeConfianceJours) {
  const res = await axiosInstance.post(`${BASE}/demandes/${id}/approuver`, { commentaire, dureeConfianceJours });
  return res?.data;
}

export async function rejeterDemande(id, commentaire) {
  const res = await axiosInstance.post(`${BASE}/demandes/${id}/rejeter`, { commentaire });
  return res?.data;
}

/* ── Actions sur un appareil ── */
export async function revoquerAppareil(lienId, commentaire) {
  const res = await axiosInstance.post(`${BASE}/appareils/${lienId}/revoquer`, { commentaire });
  return res?.data;
}

export async function bloquerAppareil(lienId, commentaire) {
  const res = await axiosInstance.post(`${BASE}/appareils/${lienId}/bloquer`, { commentaire });
  return res?.data;
}

/**
 * Compte compromis : révoque tous les appareils du titulaire et ferme toutes
 * ses sessions. À ne proposer que depuis le détail d'un appareil, où l'on sait
 * de quel compte il s'agit.
 */
export async function reinitialiserAppareils(utilisateurTrackingId, commentaire) {
  const res = await axiosInstance.post(
    `${BASE}/utilisateurs/${utilisateurTrackingId}/reinitialiser-appareils`, { commentaire });
  return res?.data;
}

/**
 * Vocabulaire des statuts - miroir de StatutAppareilUtilisateur côté backend.
 *
 * Les couleurs disent la décision à prendre, pas l'état technique : vert = rien
 * à faire, ambre = quelqu'un attend, rouge = accès coupé, gris = dormant.
 */
export const STATUTS_APPAREIL = avecLibelleTraduit({
  DE_CONFIANCE: { color: 'green' },
  VERIFIE_SESSION: { color: 'cyan' },
  EN_ATTENTE_VERIFICATION: { color: 'blue' },
  EN_ATTENTE_VALIDATION_ADMIN: { color: 'orange' },
  EXPIRE: { color: 'default' },
  REVOQUE: { color: 'default' },
  REJETE: { color: 'red' },
  BLOQUE: { color: 'red' },
}, 'referentiels:statutsAppareil');

export const METHODES_CONFIANCE = libellesTraduits('referentiels:methodesConfiance');

export const TYPES_APPAREIL = libellesTraduits('referentiels:typesAppareil');

export const MOTIFS_DEMANDE = libellesTraduits('referentiels:motifsDemandeValidation');

/** Événements du journal de sécurité, avec le ton qui convient à chacun. */
export const EVENEMENTS_SECURITE = avecLibelleTraduit({
  CONNEXION_APPAREIL_CONNU: { color: 'green' },
  CONNEXION_APPAREIL_INCONNU: { color: 'orange' },
  INCOHERENCE_EMPREINTE: { color: 'red' },
  OTP_ENVOYE: { color: 'blue' },
  OTP_VALIDE: { color: 'green' },
  OTP_ECHEC: { color: 'volcano' },
  OTP_BLOQUE: { color: 'red' },
  APPAREIL_MIS_EN_CONFIANCE: { color: 'green' },
  DEMANDE_VALIDATION_CREEE: { color: 'orange' },
  APPAREIL_VALIDE_ADMIN: { color: 'green' },
  APPAREIL_REJETE_ADMIN: { color: 'red' },
  APPAREIL_REVOQUE: { color: 'volcano' },
  APPAREIL_BLOQUE: { color: 'red' },
  APPAREIL_RENOMME: { color: 'default' },
  SESSIONS_REVOQUEES: { color: 'volcano' },
}, 'referentiels:evenementsSecurite');
